import { combineReducers } from "redux";
import { ActionType } from "typesafe-actions";
import * as actions from "./actions";
import { REMOVE_TOKEN, SET_TOKEN } from "./constants";

export type Action = ActionType<typeof actions>;

export type State = Readonly<{
  apiToken: string | null;
}>;

export default combineReducers<State, Action>({
  apiToken: (state = null, action: Action) => {
    switch (action.type) {
      case REMOVE_TOKEN:
        return action.token;
      case SET_TOKEN:
        return action.token;
      default:
        return state;
    }
  },
});
